import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { List, Datagrid, FilterForm } from 'components/list';
import { DateInput, AutocompleteInput, SelectInput } from 'components/input';
import { TextField } from 'components/field/index';
import { EditButton } from 'components/button';

import { crudGetList as crudGetListAction } from 'actions/dataActions';

import { AdminUserResourceName, adminUserBackendPath } from 'routes/user';

import * as utils from './utils';
import * as urls from "./urls";

class BannerFilter extends Component {
  static propTypes = {
    userChoices: PropTypes.array,
  };

  static defaultProps = {
    userChoices: [],
  };

  render() {
    const { userChoices } = this.props;

    return (
      <FilterForm name='news_filter' {...this.props}>
        <DateInput source='create_time_start' label='Create From'/>
        <DateInput source='create_time_end' label='Create To'/>
        <AutocompleteInput source='last_updated_by' label='Last Updated By' choices={userChoices}/>
        <SelectInput source='status' label='Status' allowEmpty={true} choices={utils.DISPLAY_BANNER_STATUS_CHOICES}/>
      </FilterForm>
    );
  }
}


class BannerListBase extends Component {

  static propTypes = {
    userIds: PropTypes.array,
    users: PropTypes.object,
  };

  static defaultProps = {
    userIds: [],
    users: {},
  };

  componentDidMount() {
    this.props.crudGetList(AdminUserResourceName, adminUserBackendPath);
  }

  render() {
    const { userIds, users } = this.props;

    const userChoices = userIds.map((userId) => ({ 'id': userId, 'name': users[userId].username }));

    return (
      <List filters={<BannerFilter userChoices={userChoices} />} hasCreate={true} {...this.props}>
        <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
          <TextField source="id" label="ID"/>
          <TextField source="description" label="Description"/>
          <TextField source="created_at" label="Create Time"/>
          <TextField source="last_updated_by" label="Last Updated By"/>
          <TextField source="image_path" label="Image URL"/>
          <TextField source="redirect_url" label="Redirect URL"/>
          <TextField source="valid_from" label="Valid From"/>
          <TextField source="valid_to" label="Valid To"/>
          <TextField source="priority" label="Priority"/>
          <TextField source="status_display" label="Status"/>
          <EditButton linkTo={urls.bannerEditFrontendPath} label="Edit"/>
        </Datagrid>
      </List>
    );
  }
}

export const BannerList = connect(
  (state) => ({
    userIds: state.admin[AdminUserResourceName].list.ids,
    users: state.admin[AdminUserResourceName].data,
    isLoading: state.admin.loading > 0,
  }),
  { crudGetList: crudGetListAction },
)(BannerListBase);


// WEBPACK FOOTER //
// ./src/routes/news/BannerList.js